const forestGreen = {
    50: '#c4d7be',
    100: '#9aba91',
    200: '#7da870',
    300: '#689a5b',
    400: '#3b7c29',
}
export default forestGreen;
